import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import setNullEmptyValues from 'common/util/setNullEmptyValues';

import { MEDIA_TYPE_3D_TOUR, MEDIA_TYPE_VIDEO } from 'common/mediaHelpers';

import { SR_API_ACTION_MEDIA_UPSERT } from 'api/actionTypes';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrText from 'client/components/SrText';
import SrFormikField, { SR_FIELD_THEME_PARTNER_FORM } from 'client/components/SrFormikField';

import postWithState from 'client/actions/postWithState';
import withApiState from 'client/helpers/withApiState';

const getFormFields = (formValues = {}) => [
  {
    id: 'id',
    type: 'hidden',
  },
  {
    id: 'apartmentId',
    type: 'hidden',
  },
  {
    id: 'apartmentBuildingId',
    type: 'hidden',
  },
  {
    id: 'floorPlanId',
    type: 'hidden',
  },
  {
    id: 'listingId',
    type: 'hidden',
  },
  {
    id: 'type',
    title: 'type',
    type: 'select',
    properties: {
      choices: [
        {
          label: '3D Tour',
          value: MEDIA_TYPE_3D_TOUR,
        },
        {
          label: 'Video',
          value: MEDIA_TYPE_VIDEO,
        },
      ],
    },
    validations: ['required'],
  },
  {
    id: 'url',
    title: formValues.type === MEDIA_TYPE_VIDEO ? 'video url' : '3d url',
    type: 'short_text',
    properties: {
      placeholder: 'Write url...',
    },
    validations: ['required', 'url'],
  },
  {
    id: 'description',
    title: 'description',
    type: 'long_text',
    properties: {
      placeholder: 'Write here...',
    },
  },
];

@withApiState({
  upsertMediaApiState: {
    action: SR_API_ACTION_MEDIA_UPSERT,
  },
})
class SrUpsertMediaModal extends Component {
  static propTypes = {
    defaultValues: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,
    upsertMediaApiState: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    title: PropTypes.string,
  };

  static defaultProps = {
    defaultValues: {},
  };

  _onSubmit = (formValues) => {
    const { onClose, onSuccess, dispatch } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_MEDIA_UPSERT,
      payload: setNullEmptyValues(formValues),
      onSuccess: (media) => {
        if (typeof onSuccess === 'function') {
          onSuccess(media);
        }
        onClose();
      },
    });
  };

  render() {
    const { title, defaultValues, upsertMediaApiState, onClose } = this.props;

    const isNew = !defaultValues.id;

    return (
      <SrDarkModal onClose={onClose} className="SrUpsertMediaModal">
        <SrModalContent onCloseIconClick={onClose}>
          <Formik
            validate={(values) => {
              const formFields = getFormFields(values);
              return createFormValidationFn(formFields)(values);
            }}
            initialValues={createInitialValues({
              formFields: getFormFields(),
              defaultValues: defaultValues,
            })}
            onSubmit={this._onSubmit}
            render={(formikBag) => {
              const formFields = getFormFields(formikBag.values);
              return (
                <Form>
                  <div className="container">
                    <div className="header">
                      <SrText size="28" weight="600">
                        {title}
                      </SrText>
                    </div>
                    <div className="content">
                      {formFields.map((formField) => (
                        <SrFormikField
                          key={formField.id}
                          formField={formField}
                          formikBag={formikBag}
                          className={SR_FIELD_THEME_PARTNER_FORM}
                        />
                      ))}
                    </div>
                    <div className="footer">
                      <span onClick={onClose} className="cancelButton cursor-pointer">
                        Cancel
                      </span>
                      <ButtonDeprecated
                        type="submit"
                        className="submitButton"
                        disabled={!formikBag.isValid || upsertMediaApiState.inProgress}
                      >
                        {upsertMediaApiState.inProgress ? 'saving...' : isNew ? 'create' : 'update'}
                      </ButtonDeprecated>
                      {upsertMediaApiState.error && (
                        <div className="formMessageError">
                          <span>{upsertMediaApiState.error}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </Form>
              );
            }}
          />
        </SrModalContent>
      </SrDarkModal>
    );
  }
}

SrUpsertMediaModal.displayName = 'SrUpsertMediaModal';

export default SrUpsertMediaModal;
